import { render, staticRenderFns } from "./product-type-selector.vue?vue&type=template&id=66cabd19"
import script from "./product-type-selector.vue?vue&type=script&lang=js"
export * from "./product-type-selector.vue?vue&type=script&lang=js"
import style0 from "./product-type-selector.vue?vue&type=style&index=0&id=66cabd19&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports